import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { Button, TextField } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { Edit } from '@material-ui/icons';
import { putLinkVideo } from '../../../services';

const QUERY_NAME = 'Virtual%20Tour%20Toll%20Road';

const initVideoState = {
  link: '',
};

// function isYouTubeLink(link: any) {
//   // Pola regulernya untuk mengenali tautan YouTube yang valid
//   const youtubeLinkPattern = /^https:\/\/youtu\.be\/([a-zA-Z0-9_-]+)$/;

//   // Gunakan metode test() untuk memeriksa apakah tautan cocok dengan pola
//   return youtubeLinkPattern.test(link);
// }

const VirtualTourTollRoad = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingState, setLoadingState] = useState(false);
  const [videoState, setVideoState] = useState(initVideoState);
  const [linkVideo, setLinkVideo] = useState('');

  const handleVideoChange = (event: any) => {
    setVideoState({
      ...videoState,
      link: event.target.value,
    });
  };

  const handleSaveVideo = async () => {
    const body = videoState;
    setLoadingState(true);

    try {
      await putLinkVideo(QUERY_NAME, body);
      setLoadingState(false);
      setVideoState(initVideoState);
      enqueueSnackbar('Update video Virtual Tour Toll Road Berhasil', {
        variant: 'success',
      });
    } catch (err: any) {
      setLoadingState(false);
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  const getData = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/video?name=${QUERY_NAME}`
      );
      const resJson = await res.json();
      setLinkVideo(resJson.data.link);
    } catch (err: any) {
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoState]);

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
        <TextField
          label='Copy video link here'
          style={{ width: '30rem' }}
          value={videoState.link}
          onChange={handleVideoChange}
        />
        <Button
          variant='contained'
          startIcon={<Edit />}
          color='primary'
          style={{ marginBottom: 16 }}
          onClick={handleSaveVideo}
          disabled={!videoState.link}
        >
          Upload Link
        </Button>
        {loadingState && <p>Uploading..</p>}
      </div>

      <ReactPlayer
        url={linkVideo}
        playing
        controls
        style={{ maxWidth: '100%' }}
        onError={() => console.log('video error')}
      />
    </div>
  );
};

export default VirtualTourTollRoad;
